import { render, staticRenderFns } from "./PaginasAmarillas.vue?vue&type=template&id=76e30719&scoped=true&"
import script from "./PaginasAmarillas.vue?vue&type=script&lang=js&"
export * from "./PaginasAmarillas.vue?vue&type=script&lang=js&"
import style0 from "./PaginasAmarillas.vue?vue&type=style&index=0&id=76e30719&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e30719",
  null
  
)

export default component.exports